import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputJobSetting2 from '../components/InputJobSetting_2';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {
    IInputJobSettings2PropsData,
    IInputJobSettings2PropsFunctions,
} from '../props/IInputJobSettings2Props';
import { ll_fetch } from '../../../tools';
import ATE from '../../../ActionTypeEnum';
import { SiteAnnotation } from '../../../IMainState';

function submitInput(dispatch: any, browserHistory: any) {
    dispatch(ActSummary.submitInput());

    browserHistory.push(clientUrlPrefix + '/summary');
}
interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

async function getSiteAnotations(
    dispatch: any,
    jobId: string,
    sequence: string,
    inputDataType: any,
) {

    dispatch({
        type: ATE.SET_SITES_ANNOTATIONS,
        value: [],
    });

    dispatch({
        type: ATE.SET_WAITING_CAT,
        value: true
    });

    if (jobId == '') {
        try {
            const response = await ll_fetch(`/api/pdb/getJobId?jobId=`);
            jobId = await response.text();
            dispatch({
                type: ATE.SET_JOB_ID,
                value: jobId,
            });
        } catch (err) {
            console.log('FAILED TO GET JOB ID');
            console.error(err);
        }
    }

    const dataType: number = inputDataType;

    await ll_fetch(`/api/CataliticResidues/getResidues?jobId=${jobId}&sequence=${sequence}&dataType=${dataType}`)
        .then((response) => response.json())
        .then(
            (
                data: Array<{
                    chain: string;
                    residueName: string;
                    siteAnnotation: Omit<SiteAnnotation, 'chain' | 'residueName'>;
                }>
            ) => {
                const annotations = data.map((x) => ({
                    chain: x.chain,
                    residueName: x.residueName,
                    ...x.siteAnnotation,
                }));
                dispatch({
                    type: ATE.UPDATE_SITES_ANNOTATIONS,
                    value: annotations,
                });
            }
        )
        .catch((err) => {
            console.log('FAILED TO GET SITE ANOTATIONS');
            console.error(err);
        });
        
        dispatch({
            type: ATE.SET_WAITING_CAT,
            value: false
        });
}


async function addUserResidue(dispatch: any, annotation: SiteAnnotation){
    dispatch({
        type: ATE.ADD_USER_RESIDUE,
        value: annotation
    });
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IInputJobSettings2PropsData => {
    return {
        maxNumSeqField: mainState.advancedOptions.maxNumSeqField,
        blastEvalField: mainState.advancedOptions.blastEvalField,
        minIdentityField: mainState.advancedOptions.minIdentityField,
        maxIdentityField: mainState.advancedOptions.maxIdentityField,
        showWaitingMSG: mainState.showWaitingCat,
        selectedSitesAnnotations: mainState.selectedSiteAnotations,
        userSiteAnnotations: mainState.userSiteAnnotations,
        sequence: mainState.sequence,
        indexes: mainState.indexes,
        ...mainState,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IInputJobSettings2PropsFunctions => ({
    submitInput: () => submitInput(dispatch, ownProps.history),
    getSiteAnotations: (jobId: string, sequence: string, inputDataType: any) =>
        getSiteAnotations(dispatch, jobId, sequence, inputDataType),
    goBack: () => ownProps.history.goBack(),
    addUserResidue: (annotation: SiteAnnotation) => addUserResidue(dispatch, annotation),
});

const InputJobSetting2Container = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(InputJobSetting2)
);
export default InputJobSetting2Container;
